import DomainCommon from './common';

const CompanyService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/company`,
                resolve, reject
            });
        });
    },
    findById: (companyId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/company/${companyId}`,
                resolve, reject
            });
        });
    },
    add(company, email) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/company`,
                jsonBody: {
                    newCompany: company,
                    companyAdminEmail: email
                },
                resolve, reject
            });
        });
    },
    update(company) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/company/${company.id}`,
                jsonBody: company,
                resolve, reject
            });
        });
    },
    joinVips({companyId, vipIds}) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/company/${companyId}/vip`,
                jsonBody: {vipIds},
                resolve, reject
            });
        });
    },
    joinNewVips({companyId, vips}) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/company/${companyId}/vip`,
                jsonBody: {vips},
                resolve, reject
            });
        });
    },
    deleteById: (companyId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchDelete({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/company/${companyId}`,
                resolve, reject
            });
        });
    },
};

export default CompanyService;



// WEBPACK FOOTER //
// ./src/service/company.js